import { FnrToggle } from "UI/FnrToggle2";

import AdminPanelNavigationTab from "./AdminPanelNavigationTab";
import {
  TabCustomHoverElement,
  TabCustomSelectedElement,
  TabItems,
  TabBar,
  NavBullet,
} from "UI/tabBarStyles";

export default function AdminPanelNavigationBar({ resizeTrigger, disabled }) {
  const toggleStyles = {
    border: "none",
    background: "transparent",
    pointerEvents: disabled ? "none" : "auto",
    opacity: disabled ? 0.75 : 1,
  };

  return (
    <TabBar>
      <FnrToggle
        triggerResize={resizeTrigger}
        style={toggleStyles}
        CustomHoverElement={TabCustomHoverElement}
        CustomSelectedElement={TabCustomSelectedElement}
      >
        <TabItems>
          <AdminPanelNavigationTab
            panel="welcome"
            text="Welcome"
            icon="fa-hands-helping"
          />
          <NavBullet />
          <AdminPanelNavigationTab
            panel="member-info"
            text="Member Info"
            icon="fa-id-card"
          />
          <NavBullet />
          <AdminPanelNavigationTab
            panel="children-info"
            text="Children Info"
            icon="fa-child"
          />
          <NavBullet />
          <AdminPanelNavigationTab
            panel="giving"
            text="Giving"
            icon="fa-money-check-alt"
          />
          <NavBullet />
          <AdminPanelNavigationTab
            panel="finishing-up"
            text="Finishing Up"
            icon="fa-tasks"
          />
        </TabItems>
      </FnrToggle>
    </TabBar>
  );
}
